package com.eladfinish.bible.contest.screens.search.usecases.searchSuggestion

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.screens.search.model.SearchSuggestion
import com.eladfinish.bible.contest.search_instruction_for_number_format
import com.eladfinish.bible.contest.search_instruction_for_word_boundary_format
import com.eladfinish.bible.contest.search_try_suggestion
import com.eladfinish.bible.contest.utils.makeVavAndYudOptional
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.desc.plus
import dev.icerock.moko.resources.format

class BuildSearchSuggestionUseCase {

    operator fun invoke(
        originalExpression: String,
        searchSuggestion: SearchSuggestion,
        hebrewGender: HebrewGender,
    ): SearchSuggestionUiModel? {
        val message: StringDesc
        val suggestedExpression: String

        when (searchSuggestion) {
            SearchSuggestion.OMIT_VAV_YUD -> {
                suggestedExpression = originalExpression.makeVavAndYudOptional()

                if (suggestedExpression == originalExpression) {
                    return null
                }

                // The gendered verb ("[{נסה/נסי}]") can't live in a format string: on the web,
                // moko-resources compiles those with an ICU MessageFormat parser, which rejects
                // the marker's braces. So the expression is appended instead of formatted in.
                message = SharedRes.strings.search_try_suggestion.desc()
                    .personalizeGender(hebrewGender) + ": $suggestedExpression".desc()
            }

            SearchSuggestion.USE_NUMBER_SIGN -> {
                suggestedExpression = "${StringConstants.HASH_TAG_SYMBOL}$originalExpression"
                message = SharedRes.strings.search_instruction_for_number_format
                    .format(suggestedExpression)
            }

            SearchSuggestion.WORD_BOUNDARY -> {
                suggestedExpression = originalExpression.trimEnd() + "!"
                message = SharedRes.strings.search_instruction_for_word_boundary_format
                    .format(suggestedExpression)
            }
        }

        return SearchSuggestionUiModel(
            message = message,
            suggestedExpression = suggestedExpression,
        )
    }
}
